const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
function SvgIconDescarga(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.04 17.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2e3a47;}")), /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.54,17H.5a.5.5,0,0,1-.5-.5V10.8a.5.5,0,0,1,1,0V16H19V10.8a.5.5,0,0,1,1,0v5.74A.5.5,0,0,1,19.54,17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.44,8.65a.5.5,0,0,1,.35.14L10,11l2.23-2.23a.5.5,0,0,1,.7,0,.5.5,0,0,1,0,.71l-2.58,2.58a.5.5,0,0,1-.7,0L7.09,9.5a.5.5,0,0,1,.35-.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10,0a.5.5,0,0,1,.5.5V11.26a.5.5,0,1,1-1,0V.5A.5.5,0,0,1,10,0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDescarga);
export default __webpack_public_path__ + "static/media/Icon_descarga.89b8515b365f4b072c02422b8d7ea660.svg";
export { ForwardRef as ReactComponent };